import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const SCRIPT_ID = "consultease-widget-script";
const WIDGET_ROOT_ID = "ce-w";

function setWidgetVisibility(isVisible) {
  const widgetRoot = document.getElementById(WIDGET_ROOT_ID);
  if (widgetRoot) {
    widgetRoot.style.display = isVisible ? "" : "none";
  }
}

export default function ConsulteaseWidget() {
  const { pathname } = useLocation();

  useEffect(() => {
    const isHomepage = pathname === "/";

    if (!isHomepage) {
      setWidgetVisibility(false);
      return undefined;
    }

    setWidgetVisibility(true);

    let script = document.getElementById(SCRIPT_ID);
    let routeChanged = false;

    const syncVisibility = () => {
      setWidgetVisibility(!routeChanged);
    };

    const handleError = () => {
      console.warn("ConsultEase widget could not be loaded.");
      script?.remove();
    };

    if (!script) {
      script = document.createElement("script");
      script.id = SCRIPT_ID;
      script.async = true;
      script.src = "https://consultease.com/widget.js";
      script.dataset.expertId = "j4jcy0n8qanmf4yjc4jpc3xa";
      script.dataset.position = "bottom-right";
      script.addEventListener("load", syncVisibility);
      script.addEventListener("error", handleError, { once: true });
      document.body.appendChild(script);
    } else {
      script.addEventListener("load", syncVisibility);
    }

    return () => {
      routeChanged = true;
      setWidgetVisibility(false);
    };
  }, [pathname]);

  return null;
}
